/*
|--------------------------------------------------------------------------
| Imports
|--------------------------------------------------------------------------
*/

import { Object3D, Vector3 } from 'three';
import { VisibleAngle } from './Types';

/*
|--------------------------------------------------------------------------
| Exports
|--------------------------------------------------------------------------
*/

export { VisibleAngle }

/*
|--------------------------------------------------------------------------
| Public Functions
|--------------------------------------------------------------------------
*/

/**
 * @return {VisibleAngle}
 */
export function GetVisibleAngle(object: Object3D, from: Vector3): VisibleAngle {
    let halfDistance = object.position.distanceTo(from) / 2;
    let local = object.worldToLocal(from.clone());

    if (local.z >= halfDistance) {
        if (local.x >= halfDistance) {
            return VisibleAngle.FrontLeft;
        } else if (local.x <= -halfDistance) {
            return VisibleAngle.FrontRight;
        } else {
            return VisibleAngle.Front;
        }
    } else if (local.z <= -halfDistance) {
        if (local.x >= halfDistance) {
            return VisibleAngle.BackLeft;
        } else if (local.x <= -halfDistance) {
            return VisibleAngle.BackRight;
        } else {
            return VisibleAngle.Back;
        }
    } else if (local.x >= halfDistance) {
        return VisibleAngle.Left;
    } else {
        return VisibleAngle.Right;
    }
}
